import { Navigate } from 'react-router'

/** Legacy route — inbox lives under /account/notifikationer/indbakke. */
const NotificationsPage: React.FC = () => (
  <Navigate to="/account/notifikationer/indbakke" replace />
)

export default NotificationsPage
